import { useEffect, useState } from "react";
import { Button } from "./Button";

export interface ThemeToggleProps {
  initialMode?: "light" | "dark";
  onChange?: (mode: "light" | "dark") => void;
}

export function ThemeToggle({ initialMode = "light", onChange }: ThemeToggleProps) {
  const [mode, setMode] = useState<"light" | "dark">(initialMode);

  useEffect(() => {
    const stored = localStorage.getItem("sf-theme-mode");
    if (stored === "light" || stored === "dark") {
      setMode(stored);
    }
  }, []);

  const toggle = () => {
    const next = mode === "light" ? "dark" : "light";
    setMode(next);
    localStorage.setItem("sf-theme-mode", next);
    document.documentElement.dataset.theme = next;
    onChange?.(next);
    window.dispatchEvent(new CustomEvent("sf-theme-change", { detail: next }));
  };

  useEffect(() => {
    document.documentElement.dataset.theme = mode;
  }, [mode]);

  return (
    <Button variant="ghost" size="sm" onClick={toggle}>
      {mode === "light" ? "Dark mode" : "Light mode"}
    </Button>
  );
}
